import { BONUS_BY_PRODUCT_CARDS_ES_MX } from "#components/bonus-by-product-cards/translations";
import { BONUS_BY_PRODUCT_TABLE_ES_MX } from "#components/tables/reports/bonus-by-product-table/translations";
import { merge } from "lodash-es";

export const financialReport = {
	label: "Cierre",
	finished: {
		end: "Cerrado: {{end}}",
		not: "El evento no ha sido cerrado",
	},
	reportIn: "Facturación del evento '{{event}}'",
	fileName: "facturacion-{{event}}",
	tabs: {
		bonusByProduct: merge(
			{
				cards: BONUS_BY_PRODUCT_CARDS_ES_MX,
			},
			BONUS_BY_PRODUCT_TABLE_ES_MX,
		),
		bonusReport: {
			title: "Bonos",
			description: "Vea todos los reportes de concesión y uso de bonos",
			filenameBonus: "bonos-otorgados",
			filenameAnticipated: "consumo-anticipado",
			filenameConsumption: "consumo",
			total: "Total de {{category}}",
			select: "Seleccione una categoría",
			selectNotFound: "Ninguna categoría encontrada",
			tabs: {
				given: "Bonos Otorgados",
				used: "Bonos Utilizados",
			},
			columns: {
				client: "Empleado Responsable",
				category: "Categoría",
				date: "Fecha",
				reason: "Motivo",
				receivedValue: "Recibido",
				spentValue: "Gastado en el evento",
				spentValueInOtherEvents: "Gastado en otros eventos",
				givenBy: "Otorgado por",
				total: "Total",
			},
		},
	},
};
